import { const_var, params } from "../../../redux/reducers/reducer";
import * as cuBuilding from "../../../redux/reducers/building_pricing/pricingReducer";
import * as utils from "../../../redux/reducers/utils";
import centerBuildingsWallOptionsHelpers from "../../building/building_wall/centerBuildingsWallOptions.helpers";
import { updateWainscotOnWallChange } from "../../building/building_color/wainscotColor.helper";
import { updateWallSelection } from "../../building_pricing/wall_pricing/wallPricing.helper";
export const individuealLeanWallChange = (state, action) => {
	let updatewallAction = "";
	var chkEndJtrim = false;
	var chkSideJtrim = false;
	utils.update26GAUpgradePrice();

	if (const_var.a_p_d_a.jtrim && const_var.a_p_d_a.jtrim.length > 0) {
		chkEndJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "end").length > 0 ? true : false;
		chkSideJtrim = const_var.a_p_d_a.jtrim.filter((data) => data.type == "side").length > 0 ? true : false;
	}
	if (action.wall === "front_leanto_front") {
		state.params.p_b_c_b_f_f = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_f_f != "Open" && params.p_b_c_b_f_f != "Close" && params.p_b_c_b_f_f != "Half Dutch End" && params.p_b_c_b_f_f != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.front_lean_front_wall_price_changed = true;

		cuBuilding.UpdateFrontLean("walls");
	} else if (action.wall === "front_leanto_back") {
		state.params.p_b_c_b_f_b = action.value;
		state.params.b_f_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_f_b != "Open" && params.p_b_c_b_f_b != "Close" && params.p_b_c_b_f_b != "Half Dutch End" && params.p_b_c_b_f_b != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.front_lean_back_wall_price_changed = true;

		cuBuilding.UpdateFrontLean("walls");
	} else if (action.wall === "front_leanto_left") {
		state.params.p_b_c_b_f_l = action.value;
		state.params.b_f_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_f_l != "Open" && params.p_b_c_b_f_l != "Close" && params.p_b_c_b_f_l != "Half Dutch End" && params.p_b_c_b_f_l != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check_front == true && state.params.leanStyle.front === "gable") {
			const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.front_lean_left_wall_price_changed = true;
		cuBuilding.UpdateFrontLean("walls");
	} else if (action.wall === "front_leanto_right") {
		state.params.p_b_c_b_f_r = action.value;
		state.params.b_f_l_t_r = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_f_r != "Open" && params.p_b_c_b_f_r != "Close" && params.p_b_c_b_f_r != "Half Dutch End" && params.p_b_c_b_f_r != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check_front == true && state.params.leanStyle.front === "gable") {
			const_var.UpdatedPriceData.front_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.front_lean_right_wall_price_changed = true;
		cuBuilding.UpdateFrontLean("walls");
	} else if (action.wall === "back_leanto_back") {
		state.params.p_b_c_b_b_b = action.value;
		state.params.b_b_l_t_f = action.value;
		if (params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && params.p_b_c_b_b_b != "Half Dutch End" && params.p_b_c_b_b_b != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_b_b != "Open" && params.p_b_c_b_b_b != "Close" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.back_lean_back_wall_price_changed = true;

		cuBuilding.UpdateBackLean("walls");
	} else if (action.wall === "back_leanto_left") {
		state.params.p_b_c_b_b_l = action.value;
		state.params.b_b_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_b_l != "Open" && params.p_b_c_b_b_l != "Close" && params.p_b_c_b_b_l != "Half Dutch End" && params.p_b_c_b_b_l != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check_back == true && state.params.leanStyle.back === "gable") {
			const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.back_lean_left_wall_price_changed = true;
		cuBuilding.UpdateBackLean("walls");
	} else if (action.wall === "back_leanto_right") {
		state.params.p_b_c_b_b_r = action.value;
		state.params.b_b_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_b_r != "Open" && params.p_b_c_b_b_r != "Close" && params.p_b_c_b_b_r != "Half Dutch End" && params.p_b_c_b_b_r != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check_back == true && state.params.leanStyle.back === "gable") {
			const_var.UpdatedPriceData.back_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.back_lean_right_wall_price_changed = true;
		cuBuilding.UpdateBackLean("walls");
	} else if (action.wall === "back_leanto_front") {
		state.params.p_b_c_b_b_f = action.value;
		state.params.b_b_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_b_f != "Open" && params.p_b_c_b_b_f != "Close" && params.p_b_c_b_b_f != "Half Dutch End" && params.p_b_c_b_b_f != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.back_lean_front_wall_price_changed = true;
		cuBuilding.UpdateBackLean("walls");
	} else if (action.wall === "left_leanto_front") {
		state.params.p_b_c_b_l_f = action.value;
		state.params.b_l_l_t_f = action.value;
		updatewallAction = action.value + action.wall;

		if (params.p_b_c_b_l_f != "Open" && params.p_b_c_b_l_f != "Close" && params.p_b_c_b_l_f != "Half Dutch End" && params.p_b_c_b_l_f != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.left_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.common_left_lean_width_changed = true;
		const_var.UpdatedPriceData.common_front_lean_width_changed = true;

		cuBuilding.UpdateLeftLean("walls");
	} else if (action.wall === "left_leanto_back") {
		state.params.p_b_c_b_l_b = action.value;
		state.params.b_l_l_t_b = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}

		if (params.p_b_c_b_l_b != "Open" && params.p_b_c_b_l_b != "Close" && params.p_b_c_b_l_b != "Half Dutch End" && params.p_b_c_b_l_b != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.left_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.common_left_lean_width_changed = true;
		const_var.UpdatedPriceData.common_back_lean_width_changed = true;

		cuBuilding.UpdateLeftLean("walls");
	} else if (action.wall === "left_leanto_left") {
		state.params.p_b_c_b_l = action.value;
		state.params.b_l_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_l != "Open" && params.p_b_c_b_l != "Close" && params.p_b_c_b_l != "Half Dutch End" && params.p_b_c_b_l != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}

		if (params.p_b_c_b_l != "Open" && params.p_b_c_b_l != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check == true && state.params.leanStyle.left === "gable") {
			const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.left_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		cuBuilding.UpdateLeftLean("walls");
	} else if (action.wall === "left_leanto_right") {
		state.params.p_b_c_b_l_r = action.value;
		state.params.b_l_l_t_r = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_l_r != "Open" && params.p_b_c_b_l_r != "Close" && params.p_b_c_b_l_r != "Half Dutch End" && params.p_b_c_b_l_r != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}

		if (params.p_b_c_b_l_r != "Open" && params.p_b_c_b_l_r != "Close" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check == true && state.params.leanStyle.left === "gable") {
			const_var.UpdatedPriceData.left_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.left_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		cuBuilding.UpdateLeftLean("walls");
	} else if (action.wall === "right_leanto_front") {
		state.params.p_b_c_b_r_f = action.value;
		state.params.b_r_l_t_f = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_r_f != "Open" && params.p_b_c_b_r_f != "Close" && params.p_b_c_b_r_f != "Half Dutch End" && params.p_b_c_b_r_f != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.right_lean_front_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.common_right_lean_width_changed = true;
		const_var.UpdatedPriceData.common_front_lean_width_changed = true;

		cuBuilding.UpdateRightLean("walls");
	} else if (action.wall === "right_leanto_back") {
		state.params.p_b_c_b_r_b = action.value;
		state.params.b_r_l_t_b = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}

		if (params.p_b_c_b_r_b != "Open" && params.p_b_c_b_r_b != "Close" && params.p_b_c_b_r_b != "Half Dutch End" && params.p_b_c_b_r_b != "Half End" && chkEndJtrim == true) {
			params.p_j_t_end = true;
		}
		const_var.UpdatedPriceData.right_lean_back_wall_price_changed = true;
		const_var.UpdatedPriceData.common_width_changed = true;
		const_var.UpdatedPriceData.common_right_lean_width_changed = true;
		const_var.UpdatedPriceData.common_back_lean_width_changed = true;

		cuBuilding.UpdateRightLean("walls");
	} else if (action.wall === "right_leanto_right") {
		state.params.p_b_c_b_r = action.value;
		state.params.b_r_l_t_r = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_r != "Open" && params.p_b_c_b_r != "Close" && params.p_b_c_b_r != "Half Dutch End" && params.p_b_c_b_r != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}
		if (params.add_storage_check_right == true && state.params.leanStyle.right === "gable") {
			const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		}

		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		cuBuilding.UpdateRightLean("walls");
	} else if (action.wall === "right_leanto_left") {
		state.params.p_b_c_b_r_r = action.value;
		state.params.b_r_l_t_l = action.value;
		updatewallAction = action.value + action.wall;
		if (params.p_b_c_b_r_r != "Open" && params.p_b_c_b_r_r != "Close" && params.p_b_c_b_r_r != "Half Dutch End" && params.p_b_c_b_r_r != "Half End" && chkSideJtrim == true) {
			params.p_j_t = true;
		}

		if (params.add_storage_check_right == true && state.params.leanStyle.right === "gable") {
			const_var.UpdatedPriceData.right_lean_utility_price_changed = true;
		}
		const_var.UpdatedPriceData.right_lean_right_wall_price_changed = true;
		const_var.UpdatedPriceData.right_lean_left_wall_price_changed = true;
		const_var.UpdatedPriceData.common_length_changed = true;
		const_var.UpdatedPriceData.common_left_lean_length_changed = true;
		const_var.UpdatedPriceData.common_right_lean_length_changed = true;
		cuBuilding.UpdateRightLean("walls");
	}

	if (state.params.p_b_c_b_f_l == "Close" && state.params.p_b_c_b_f_b == "Close" && state.params.p_b_c_b_f_f == "Close" && state.params.p_b_c_b_f_r == "Close") {
		const_var.setLeanWallOption.frontLean = "close";
	} else if (state.params.p_b_c_b_f_l == "Open" && state.params.p_b_c_b_f_b == "Open" && state.params.p_b_c_b_f_f == "Open" && state.params.p_b_c_b_f_r == "Open") {
		const_var.setLeanWallOption.frontLean = "open";
	} else {
		const_var.setLeanWallOption.frontLean = "partial";
	}

	if (state.params.p_b_c_b_r == "Close" && state.params.p_b_c_b_r_b == "Close" && state.params.p_b_c_b_r_f == "Close" && state.params.p_b_c_b_r_r == "Close") {
		const_var.setLeanWallOption.rightLean = "close";
	} else if (state.params.p_b_c_b_r == "Open" && state.params.p_b_c_b_r_b == "Open" && state.params.p_b_c_b_r_f == "Open" && state.params.p_b_c_b_r_r == "Open") {
		const_var.setLeanWallOption.rightLean = "open";
	} else {
		const_var.setLeanWallOption.rightLean = "partial";
	}
	//--- left lean wall
	if (state.params.p_b_c_b_l == "Close" && state.params.p_b_c_b_l_b == "Close" && state.params.p_b_c_b_l_f == "Close" && state.params.p_b_c_b_l_r == "Close") {
		const_var.setLeanWallOption.leftLean = "close";
	} else if (state.params.p_b_c_b_l == "Open" && state.params.p_b_c_b_l_b == "Open" && state.params.p_b_c_b_l_f == "Open" && state.params.p_b_c_b_l_r == "Open") {
		const_var.setLeanWallOption.leftLean = "open";
	} else {
		const_var.setLeanWallOption.leftLean = "partial";
	}
	if (state.params.p_b_c_b_b_l == "Close" && state.params.p_b_c_b_b_b == "Close" && state.params.p_b_c_b_b_f == "Close" && state.params.p_b_c_b_b_r == "Close") {
		const_var.setLeanWallOption.backLean = "close";
	} else if (state.params.p_b_c_b_b_l == "Open" && state.params.p_b_c_b_b_b == "Open" && state.params.p_b_c_b_b_f == "Open" && state.params.p_b_c_b_b_r == "Open") {
		const_var.setLeanWallOption.backLean = "open";
	} else {
		const_var.setLeanWallOption.backLean = "partial";
	}
	centerBuildingsWallOptionsHelpers.syncCenterFullEnclosure(state);
	updateWainscotOnWallChange();
	if (const_var.isInsulaltionForOldQuotes) const_var.UpdatedPriceData.insulation_price = undefined;
	if (action.typeofLean == "left") {
		if (params.insulation.leftLean.fullBuilding || params.insulation.leftLean.custom) const_var.UpdatedPriceData.left_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;
		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
		}

		utils.update26GAUpgradePrice("left");

		cuBuilding.cPforLLeanOnly(const_var.leanGetDataLeft);
	}
	if (action.typeofLean == "right") {
		if (params.insulation.rightLean.fullBuilding || params.insulation.rightLean.custom) const_var.UpdatedPriceData.right_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
		}

		utils.update26GAUpgradePrice("right");

		cuBuilding.cPforRLeanOnly(const_var.leanGetDataRight);
	}
	if (action.typeofLean == "front") {
		if (params.insulation.frontLean.fullBuilding || params.insulation.frontLean.custom) const_var.UpdatedPriceData.front_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
		}

		utils.update26GAUpgradePrice("front");

		cuBuilding.cPforFLeanOnly(const_var.leanGetDataFront);
	}
	if (action.typeofLean == "back") {
		if (params.insulation.backLean.fullBuilding || params.insulation.backLean.custom) const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;
		const_var.UpdatedPriceData.wainscot_price_changed = true;

		const_var.UpdatedPriceData.insulation_price_changed = true;
		const_var.UpdatedPriceData.roof_color_price_changed = true;
		const_var.UpdatedPriceData.wall_color_price_changed = true;
		const_var.UpdatedPriceData.trim_color_price_changed = true;
		const_var.UpdatedPriceData.surcharge_amount = undefined;
		if (const_var.c_f_a_per[params.p_e_i] && const_var.c_f_a_per[params.p_e_i] != 0) {
			const_var.UpdatedPriceData.certificate_price_changed = true;
		}

		utils.update26GAUpgradePrice("back");

		cuBuilding.cPforBLeanOnly(const_var.leanGetDataBack);
	}
	return {
		...state,
		newColor: updatewallAction
	};
};
export const deleteUncheckWallsfromInsulationWalls = (postData) => {
	if (params.p_c_i == true && postData != undefined) {
		if (
			postData.insulation_type != undefined &&
			Object.keys(postData.insulation_type).length > 0 &&
			postData.insulation_type.insulation_wall != undefined &&
			Object.keys(postData.insulation_type.insulation_wall).length > 0
		) {
			Object.entries(postData.insulation_type.insulation_wall).forEach(([key, value]) => {
				if (value == false) {
					delete postData.insulation_type.insulation_wall[key];
				}
			});
		}
		if (postData.insulation_type != undefined && (postData.insulation_type.insulation_wall == undefined || Object.keys(postData.insulation_type.insulation_wall).length == 0)) {
			delete postData.insulation_type;
		}
		if (postData.leanto != undefined && postData.leanto.length > 0) {
			Object.entries(postData.leanto).map(([key, value]) => {
				if (value.leanto_type == 1 && value.insulation_type != undefined && value.insulation_type.insulation_wall != undefined && Object.keys(value.insulation_type.insulation_wall).length > 0) {
					Object.entries(value.insulation_type.insulation_wall).forEach(([key1, val]) => {
						if (val == false) {
							delete value.insulation_type.insulation_wall[key1];
						}
					});
				}

				if (value.leanto_type == 2 && value.insulation_type != undefined && value.insulation_type.insulation_wall != undefined && Object.keys(value.insulation_type.insulation_wall).length > 0) {
					Object.entries(value.insulation_type.insulation_wall).forEach(([key1, val]) => {
						if (val == false) {
							delete value.insulation_type.insulation_wall[key1];
						}
					});
				}

				if (value.leanto_type == 3 && value.insulation_type != undefined && value.insulation_type.insulation_wall != undefined && Object.keys(value.insulation_type.insulation_wall).length > 0) {
					Object.entries(value.insulation_type.insulation_wall).forEach(([key1, val]) => {
						if (val == false) {
							delete value.insulation_type.insulation_wall[key1];
						}
					});
				}

				if (value.leanto_type == 4 && value.insulation_type != undefined && value.insulation_type.insulation_wall != undefined && Object.keys(value.insulation_type.insulation_wall).length > 0) {
					Object.entries(value.insulation_type.insulation_wall).forEach(([key1, val]) => {
						if (val == false) {
							delete value.insulation_type.insulation_wall[key1];
						}
					});
				}
				if (value.leanto_type == 1 && value.insulation_type != undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length == 0)) {
					delete value.insulation_type;
				}
				if (value.leanto_type == 2 && value.insulation_type != undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length == 0)) {
					delete value.insulation_type;
				}
				if (value.leanto_type == 3 && value.insulation_type != undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length == 0)) {
					delete value.insulation_type;
				}
				if (value.leanto_type == 4 && value.insulation_type != undefined && (value.insulation_type.insulation_wall == undefined || Object.keys(value.insulation_type.insulation_wall).length == 0)) {
					delete value.insulation_type;
				}
			});
		}
	}
};

export const deleteInsulationKeysForLeanTo = () => {
	if (const_var.post_data && const_var.post_data.building && const_var.post_data.building.leanto && const_var.post_data.building.leanto.length > 0) {
		const updatedLeandata = [];
		const_var.post_data.building.leanto.forEach((obj) => {
			updatedLeandata.push(obj);

			let updatedTotal = 0;
			if (obj.t_c_b != undefined) {
				updatedTotal = parseFloat(obj.t_c_b) - parseFloat(obj.insulation_price || 0);
			}
			if (obj.insulation_type != undefined) {
				delete obj.insulation_type;
				delete obj.insulation;
			}
			if (obj.insulation_price != undefined) {
				delete obj.insulation_price;
			}
			if (updatedTotal != 0) {
				obj.t_c_b = updatedTotal;
			}
		});
		const_var.post_data.building.leanto = updatedLeandata;
		const_var.post_data.building.leanto.insulation = "";
	}
};
export const updateWalkinWindowlegCutPrice = (uniqueId) => {
	let doorAPIPrice,
		isPriceChanged = false,
		onVerticalSideCost,
		onSideCost;
	const_var.entry_points.map((_door) => {
		if (_door.uniqueId == uniqueId && _door.entry_doorNewType == undefined) {
			doorAPIPrice =
				const_var.newComponentArray[_door.parent_array_key][_door.child_array_key] != undefined &&
				const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key] != undefined &&
				const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key]["Size"][_door.name] != undefined
					? const_var.newComponentArray[_door.parent_array_key][_door.child_array_key][_door.nested_array_key]["Size"][_door.name]
					: undefined;
			if (_door.cutLegCount != undefined && _door.cutLegCount != 0) {
				params.legCutFee = true;
			} else {
				params.legCutFee = false;
			}
			if (doorAPIPrice) {
				onSideCost = _door.is_price_updated ? _door.entry_price : doorAPIPrice.on_side_cost != undefined ? parseFloat(doorAPIPrice.on_side_cost) + parseFloat(doorAPIPrice.cost) : doorAPIPrice.cost;
				onVerticalSideCost = _door.is_price_updated
					? _door.entry_price
					: doorAPIPrice.vertical_side_cost != undefined
						? doorAPIPrice.vertical_side_cost == 0
							? parseFloat(doorAPIPrice.on_side_cost) + parseFloat(doorAPIPrice.cost)
							: parseFloat(doorAPIPrice.vertical_side_cost) + parseFloat(doorAPIPrice.cost)
						: doorAPIPrice.cost;
				const checkPrice = params.p_v_w ? onVerticalSideCost : onSideCost;

				if (params.legCutFee && _door.entry_price != checkPrice) {
					_door.entry_price = params.p_v_w ? onVerticalSideCost : onSideCost;
					isPriceChanged = true;
				}
				if (!params.legCutFee && parseFloat(_door.entry_price) !== parseFloat(doorAPIPrice.cost)) {
					_door.entry_price = _door.is_price_updated ? _door.entry_price : doorAPIPrice.cost != undefined ? doorAPIPrice.cost : _door.entry_price;
					isPriceChanged = true;
				}
			}
		}
	});
	if (const_var.legCutFlag != undefined && const_var.legCutFlag == true) {
		cuBuilding.cP();
	}
	return isPriceChanged;
};

export const onForceLeantoRemoval = () => {
	if (params.p_w_c_n) {
		if (
			params.p_f_w == "Close" ||
			params.p_b_w == "Close" ||
			params.p_l_w == "Close" ||
			params.p_r_w == "Close" ||
			params.p_u_c ||
			params.cB_addStorage_check_left ||
			params.cB_addStorage_check_right ||
			params.p_b_c_b_l_f == "Close" ||
			params.p_b_c_b_l == "Close" ||
			params.p_b_c_b_l_b == "Close" ||
			params.add_storage_check ||
			params.p_b_c_b_r_f == "Close" ||
			params.p_b_c_b_r == "Close" ||
			params.p_b_c_b_r_b == "Close" ||
			params.add_storage_check_right ||
			params.p_b_c_b_f_f == "Close" ||
			params.p_b_c_b_f_b == "Close" ||
			params.p_b_c_b_f_l == "Close" ||
			params.add_storage_check_front ||
			params.p_b_c_b_b_f == "Close" ||
			params.p_b_c_b_b_b == "Close" ||
			params.p_b_c_b_b_l == "Close" ||
			params.add_storage_check_back ||
			params.p_f_w == "Half Dutch End" ||
			params.p_f_w == "Half End" ||
			params.p_b_w == "Half Dutch End" ||
			params.p_b_w == "Half End" ||
			params.p_b_c_b_l_f == "Half Dutch End" ||
			params.p_b_c_b_l_f == "Half End" ||
			params.p_b_c_b_l_b == "Half Dutch End" ||
			params.p_b_c_b_l_b == "Half End" ||
			params.p_b_c_b_b_f == "Half Dutch End" ||
			params.p_b_c_b_b_f == "Half End" ||
			params.p_b_c_b_b_b == "Half Dutch End" ||
			params.p_b_c_b_b_b == "Half End" ||
			params.p_b_c_b_f_f == "Half Dutch End" ||
			params.p_b_c_b_f_f == "Half End" ||
			params.p_b_c_b_f_b == "Half Dutch End" ||
			params.p_b_c_b_f_b == "Half End" ||
			params.p_b_c_b_r_f == "Half Dutch End" ||
			params.p_b_c_b_r_f == "Half End" ||
			params.p_b_c_b_r_b == "Half Dutch End" ||
			params.p_b_c_b_r_b == "Half End"
		) {
			const_var.showWainscotJSX = true;
		} else {
			const_var.showWainscotJSX = false;
			params.p_w_c_n = false;
		}
	}
};
export const updateFunctionsOnLeantoRemoval = (leanType) => {
	if (leanType == "frontLean") {
		params.add_front_lean = params.add_storage_check_front = false;
		const_var.leanFHasDoublelegshow = params.leanF_p_e_l = false;
		params.insulation.frontLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
		params.isShowCenter = false;
		params.leanF_p_d = 21;
		params.leanF_p_h = const_var.b_m_i_hlean;
		params.b_l_t_r_pF = "2";
		params.p_b_c_b_f_f = params.p_b_c_b_f_b = params.p_b_c_b_f_l = "Open";
		if (params.add_left_front_lean_porch || params.add_right_front_lean_porch) {
			if (params.add_left_front_lean_porch) {
				params.add_left_front_lean_porch = false;
			}
			if (params.add_right_front_lean_porch) {
				params.add_right_front_lean_porch = false;
			}
		}

		cuBuilding.removeDataFromArray(3);
	}
	if (leanType == "backLean") {
		params.add_back_lean = params.add_storage_check_back = false;
		const_var.leanBHasDoublelegshow = params.leanB_p_e_l = false;
		params.insulation.backLean = { showInsulation: false, isCheked: false, insulationId: 0, roofOnly: false, fullBuilding: false, showInsulationOptions: false, isDisableFullInsulation: false };
		params.isShowCenter = false;
		params.leanB_p_d = 21;
		params.leanB_p_h = const_var.b_m_i_hlean;
		params.b_l_t_r_pB = "2";
		params.p_b_c_b_b_f = params.p_b_c_b_b_b = params.p_b_c_b_b_l = "Open";
		if (params.add_left_back_lean_porch || params.add_right_back_lean_porch) {
			if (params.add_left_back_lean_porch) {
				params.add_left_back_lean_porch = false;
			}
			if (params.add_right_back_lean_porch) {
				params.add_right_back_lean_porch = false;
			}
		}

		cuBuilding.removeDataFromArray(3);
	}

	onForceLeantoRemoval();
	cuBuilding.cP();
};
export const calculateLeanWallData = ({ sideWall, sideWallRear, endWallFront, endWallBack, isStorage, storagePosition, storageLength, leanDepth, leanStyle }) => {
	let closedEndWalls = 0;
	let closedSideWalls = 0;
	let fullclosedEndWalls = 0;
	let fullclosedSideWalls = 0;

	if (sideWall !== "Open") closedSideWalls++;
	if (sideWallRear !== "Open") closedSideWalls++;

	if (endWallFront !== "Open") closedEndWalls++;
	if (endWallBack !== "Open") closedEndWalls++;

	if (sideWall === "Close") fullclosedSideWalls++;
	if (sideWallRear === "Close") fullclosedSideWalls++;

	if (endWallFront === "Close") fullclosedEndWalls++;
	if (endWallBack === "Close") fullclosedEndWalls++;

	if (isStorage) {
		closedSideWalls = leanStyle === "gable" ? 2 : 1;
		fullclosedSideWalls = leanStyle === "gable" ? 2 : 1;

		closedEndWalls++;
		fullclosedEndWalls++;

		if (storagePosition != 0 && parseFloat(storagePosition) + parseFloat(storageLength) != leanDepth) {
			closedEndWalls++;
			fullclosedEndWalls++;
		}
	}

	return {
		closedSideWalls,
		closedEndWalls,
		fullclosedSideWalls,
		fullclosedEndWalls
	};
};
export const updateLeanWallData = ({ wallKey, wallData, walls }) => {
	const_var.wallsData[wallKey].closedSideWalls = wallData.closedSideWalls;

	const_var.wallsData[wallKey].closedEndWalls = wallData.closedEndWalls;

	const_var.wallsData[wallKey].fullclosedSideWalls = wallData.fullclosedSideWalls;

	const_var.wallsData[wallKey].fullclosedEndWalls = wallData.fullclosedEndWalls;

	Object.assign(const_var.wallsData[wallKey], walls);
};
export const finalizeLeanUpdate = () => {
	updateWallSelection();
	utils.prepareLoftDropdown();
};
